import React, { ReactNode, useState } from "react"
import { CgClose } from "react-icons/cg"
import styled from "styled-components"
import ConfirmUpdateFundFact from "./confirmUpdateFundFact"
import UpdateFundFactForm from "./updateFundfact"

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: #20200020;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalBox = styled.div`
  position: relative;
  padding: 50px;
  max-width: 30%;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
`

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  appearance: none;
  background-color: transparent;
  border: 0;
  padding: 15px;
`

export enum UpdateFundFact {
  Form,
  Confirm,
  Error,
}

const ModalCard = ({
  onClose,
  children,
}: {
  onClose: () => void
  children: ReactNode
}) => {
  return (
    <ModalBox
      data-testid="modalCard"
      onClick={(ev) => {
        ev.stopPropagation()
      }}
    >
      <CloseButton onClick={() => onClose()}>
        <CgClose size={24} />
      </CloseButton>
      {children}
    </ModalBox>
  )
}

const UpdateFundFactModal = ({
  fundId,
  clientFund,
  assetClass,
  subCategory,
  percentage,
  onClose,
  parent2Callback,
}: {
  fundId: string
  clientFund: string
  assetClass: string
  subCategory: string
  percentage: number
  onClose: () => void
  parent2Callback: () => void
}) => {
  const [step, setStep] = useState<UpdateFundFact>(UpdateFundFact.Form)
  const [data, setData] = useState<{
    fundId: string
    clientFund: string
    assetClass: string
    subcategoryEdit: string
    percentageEdit: number
    error: string
  }>({
    fundId,
    clientFund,
    assetClass,
    subcategoryEdit: "",
    percentageEdit: 0,
    error: "",
  })

  return (
    <Overlay onClick={() => setStep(UpdateFundFact.Form)}>
      <ModalCard onClose={onClose}>
        {step === UpdateFundFact.Form && (
          <UpdateFundFactForm
            fundId={fundId}
            clientFund={clientFund}
            assetClass={assetClass}
            subCategory={subCategory}
            percentage={percentage}
            onSubmit={(subcategoryEdit, percentageEdit) => {
              setData((prev) => ({
                ...prev,
                subcategoryEdit,
                percentageEdit,
              }))
              setStep(UpdateFundFact.Confirm)
            }}
          />
        )}
        {step === UpdateFundFact.Confirm && (
          <ConfirmUpdateFundFact
            fundId={data.fundId}
            clientFund={data.clientFund}
            assetClass={data.assetClass}
            subcategory={data.subcategoryEdit}
            percentage={data.percentageEdit}
            onCancel={() => onClose()}
            onError={(error) => {
              setData((prev) => ({ ...prev, error }))
              setStep(UpdateFundFact.Error)
            }}
            onSuccess={() => onClose()}
            parentCallback={() => parent2Callback()}
          />
        )}
        {step === UpdateFundFact.Error && `API Error: ${data.error}`}
      </ModalCard>
    </Overlay>
  )
}

export default UpdateFundFactModal
